import { useEffect, useRef, useState } from "react";
import { getLocationMedia, onLocationMediaChanged } from "../../data/locationMediaClient.js";
import { safeMediaUrl } from "../projects/media/MediaStrip.jsx";

export function officeCoverDescriptor(item) {
  const src = item?.type === "image" ? safeMediaUrl(item.url) : null;
  return src ? { id: item.id, src, caption: item.caption || "" } : null;
}
// Failed reads never overwrite a confirmed cover. Identity changes immediately
// hide old state; the retained legacy photo is only an initial compatibility read.
const OFFICE_COVER_ADAPTER = Object.freeze({ list: getLocationMedia, subscribe: onLocationMediaChanged });
export function useOfficeCover(id, enabled, identity, legacyUrl, reloadToken, adapter = OFFICE_COVER_ADAPTER) {
  const [state, setState] = useState(null);
  const seq = useRef(0);
  useEffect(() => {
    if (!enabled || !id) return undefined;
    let active = true;
    const load = () => {
      const mine = ++seq.current;
      Promise.resolve().then(() => adapter.list(id)).then(result => {
        if (active && mine === seq.current) setState({ id, identity, cover: officeCoverDescriptor(result.effectiveCover) });
      }).catch(() => { /* The gallery owns the retryable error; keep last-good decoration. */ });
    };
    load();
    const refresh = () => { if (document.visibilityState !== "hidden") load(); };
    window.addEventListener("focus", refresh);
    const interval = setInterval(refresh, 60000);
    const off = adapter.subscribe(id, detail => {
      if (detail?.result && Object.hasOwn(detail.result, "effectiveCover")) {
        ++seq.current;
        setState({ id, identity, cover: officeCoverDescriptor(detail.result.effectiveCover) });
      } else load();
    });
    return () => { active = false; seq.current++; off(); clearInterval(interval); window.removeEventListener("focus", refresh); };
  }, [id, enabled, identity, legacyUrl, reloadToken, adapter]);
  if (!enabled) return null;
  if (state?.id === id && state.identity === identity) return state.cover;
  return officeCoverDescriptor({ type: "image", url: legacyUrl, caption: "", id: null });
}
